import React from 'react'
import { Typography } from '@mui/material';
import Sidebar from '../Components/Layout/Sidebar';
import classes from "../Components/Home/Home.module.css"
import { ContentLayout } from '../Components/UI/Template/ContentLayout';
import { Leftpart } from '../Components/UI/Template/Leftpart';
import { RightPart } from '../Components/UI/Template/Rightpart';
import { Block } from '@mui/icons-material';

const Unauthorize = () => {
  return (
    <ContentLayout>
        <Leftpart>
          <Sidebar unauthorize={true} />
        </Leftpart>
        <RightPart>
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '88vh'}}>
          <Block sx={{mr: 0.5, position: 'absolute', opacity: '0.2', fontSize: '10em'}} />
            <Typography sx={{ml: 0.5, color: '#6a6a6a', letterSpacing: '2px', fontSize :'1.5em'}} variant='p'>SORRY!! YOU ARE NOT AUTHORIZED</Typography>
          </div>
        </RightPart>
      </ContentLayout>
  )
}

export default Unauthorize